export const About = (props) => {
  return (
    <div id="about">
    <div className="about-style2-area">
   
    <div className="container">
        <div className="row">
            <div className="col-md-6 col-lg-6">
                 <div className="about-style2-image-box ">
            <img src="img/about-style2-man.jpg" alt="" />
           
        </div>
            </div>
            <div className="col-md-6 col-lg-6">
                <div className="about-style2_content">
                    <div className="sec-title">
                        <div className="sub-title">
                            <h5></h5>
                        </div>
                        <h2>We Welcome</h2>
                        
                    </div>
                    <div className="inner-content">
                       
                  <div className="text">
                    <p>Expert RO service are committed to providing reliable and affordable R O water purifier service and repair solutions.With years of experience.We help families and businesses access clean.safe and great-tasting drinking water every day.
                      We understand how important pure water is for your health.That's why our skilled technicians focus on providing quality service.quick response times and long-lasting solutions for your R O water purifier system.We guarantee service within just 1 hour. Simply give us a.
                    </p>
                  </div>
                    </div> 
                    <div className="bottom-box">
                        
                        <div className="highlights-box">
                            <ul>
                                <li className="wow fadeInRight" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="icon">
                                        <div className="icon-bg" style={{ backgroundImage: "url(img/shape/sheild.png)" }}></div>
                                        <span className="icon-shield"></span>
                                    </div>
                                    <div className="text">
                                        <h3>Reliable</h3>
                                        <p>Expert RO service first carefully listens to specific client’s requirement with an open mind to understand exactly what they need. </p>
                                    </div>
                                </li>

                                <li className="wow fadeInRight" data-wow-delay="300ms" data-wow-duration="1500ms">
                                    <div className="icon">
                                        <div className="icon-bg" style={{ backgroundImage: "url(img/shape/ribbon.png)" }}></div>
                                        <span className="icon-medal"></span>
                                    </div>
                                    <div className="text">
                                        <h3>Commited</h3>
                                        <p>We never offer one-size-fits-for-all services but customized solutions.</p>
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
    </div>
  );
};
